<template>
  <div class="modal">
    <div class="modal__container">
      <div class="modal__header">
        <div class="modal__title">
          {{ modalTitle }}
        </div>
        <button class="modal__close" @click="closeModal(false)">
          <i class="bx bx-x"></i>
        </button>
      </div>
      <div class="modal__body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminViewAllUsersModal",
  props: {
    modalTitle: {
      type: String,
      required: true,
      default: "Modal Title",
    },
  },
  methods: {
    closeModal(value) {
      this.$emit("close-modal", value);
    },
  },
};
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(17, 17, 17, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200000;
}
.modal .modal__container {
  position: relative;
  background-color: #fff;
  max-height: 70vh;
  overflow: hidden;
  border-radius: 4px;
  width: 60%;
  margin: 5% 0 0 20%;
  display: grid;
  grid-template-rows: 50px minmax(auto, 90%);
  /* z-index: 200000000000; */
}

@media screen and (max-width: 450px) {
  .modal .modal__container {
    margin: 0;
    width: 90%;
  }
}
@media screen and (min-width: 451px) and (max-width: 768px) {
  .modal .modal__container {
    margin: 0;
    width: 80%;
  }
}
.modal .modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  border-bottom: 1px solid #ccc;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f8f8;
  z-index: 100;
}

.modal .modal__body {
  padding: 40px 20px;
  overflow: auto;
  max-height: 100%;
  overflow-x: hidden;
}

.modal .modal__title {
  font-weight: 600;
  border-right: 1px solid #ccc;
  display: flex;
  align-items: center;
  align-self: stretch;
  padding-right: 15px;
  color: #2a41e8;
}
.modal .modal__close {
  font-size: 2rem;
  line-height: 1;
  border-left: 1px solid #ccc;
  display: flex;
  align-items: center;
  align-self: stretch;
  padding-left: 15px;
  cursor: pointer;
  transition: background-color 0.4s ease;
}
.modal .modal__close i:hover {
  color: #000;
}
</style>
